module.exports = __webpack_public_path__ + "img/swish-primary-large.717f8f92.png";